import { useState } from "react";
import { Modal,Form, Input, Button,notification } from "antd";
import {SettingFilled} from '@ant-design/icons';
import {BsFillGearFill } from "react-icons/bs";
import services from '../../../services/index'
import { DeleteOutlined } from "@ant-design/icons";
import md5 from 'md5'

import commonObj from '../../../utils/Common';

export function ChangePassword(props) { 
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showPass, setShowPass] = useState(true);

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const showModal = () => {
    setIsModalVisible(true);
    if(props?.keypass!==undefined && props?.keypass!='') setShowPass(false)
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      values['id'] = btoa(props.id);
      values['currentPassword'] = showPass ? md5(values.currentPassword) : props?.keypass
      values['newPassword'] = md5(values.newPassword);
      values['confirmPassword'] = md5(values.confirmPassword);  
        //console.log(values);
      if(!props.id){
        notification.error({message: 'You are not authorized for that!', placement:'bottomRight'}); 
      }else{ 
        let changeData = await services.usersService.updatePassword(values) ;
          if(changeData!=null && Object.keys(changeData).length > 0){  
              notification.success({message: changeData?.message, placement:'bottomRight'});
              setIsModalVisible(false);
              form.resetFields(); 
          }        
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
 
<Button type="text" icon={<BsFillGearFill className="text-md " />} onClick={showModal}>{props?.name? commonObj.getLabel('Change_Password'):''}</Button>
      <Modal
        width={300}
        title="Change Password"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {commonObj.getLabel('Cancel')}
          </Button>,
          <Button key="submit" type="primary" onClick={onFinish}>
            {commonObj.getLabel('Save')}
          </Button>,
        ]}
      >
        <Form
          form={form}
          name="form-name"
          layout="vertical"
          initialValues={initialValues}
          onFinish={onFinish}
        >
            { showPass && (<Form.Item
              label= {commonObj.getLabel('Current_Password')}
              name="currentPassword"
              hasFeedback
              rules={[
                  { required: true, message: "Please enter the Current password!" },
              ]}
              >
            <Input.Password />
            </Form.Item> )}
            <Form.Item
              label={commonObj.getLabel('New_Password')}
              name="newPassword"
              hasFeedback
              rules={[
                  { required: true, message: "Please enter the new password!" },
                  { min: 8, message: 'New password must be minimum 8 characters.' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (showPass && getFieldValue('currentPassword') === value) {
                        return Promise.reject(new Error('The new password should be different from current password!'));
                      }
                      return Promise.resolve();
                    },
                  }),
              ]}
              >
            <Input.Password />
            </Form.Item>
            <Form.Item
            label={commonObj.getLabel('Confirm_Password')}
            name="confirmPassword"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
                {
                  required: true,
                  message: 'Please enter the confirm password!',
                },

                { min: 8, message: 'Confirm password must be minimum 8 characters.' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The new password that you entered do not match!'));
                  },
                }),
              ]}
            >
            <Input.Password/>
            </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default ChangePassword;
